module.exports = __webpack_public_path__ + "img/right_hand.ed13f863.png";